import { ViewportScroller } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface configModal{
	icon:string;
	title:string;
	subtitle:string;
	description:string;
	buttons:any;
}


@Component({
	selector: 'app-help-modal',
	templateUrl: './help-modal.component.html',
	styleUrls: ['./help-modal.component.css']
})
export class HelpModalComponent implements OnInit {

	showVideo:boolean = false;

	configModal:configModal = {
		title: 'Información de ayuda',
		icon: 'fas fa-question-circle mr-1 text-success',
		subtitle: '',
		description: '',
		buttons: {
			close: {
				title: 'Cerrar',
				disabled: false
			}
		}
	}

	// loadingVideo:boolean = true;
	loadingVideo:boolean = false;

	constructor(
		public dialogRef: MatDialogRef<HelpModalComponent>,
		@Inject(MAT_DIALOG_DATA) public dataModal: {type:string, collection:string, data:any},
		private viewport:ViewportScroller
	) {}

	ngOnInit(): void {

		// console.log('HELP MODAL', this.dataModal)

		switch(this.dataModal.collection){
			case 'glaeria_post_facebook':
				this.configModal.title = 'Ayuda';
				this.configModal.subtitle = 'Vincular post de Facebook a galería League Sports';
				this.configModal.icon = 'fas fa-question-circle mr-1';
				break;
			case 'video_post_facebook':
				this.configModal.title = 'Ayuda';
				this.configModal.subtitle = 'Vincular video de Facebook a League Sports';
				this.configModal.icon = 'fas fa-question-circle mr-1';
				break;
			case 'video_post_youtube':
				this.configModal.title = 'Ayuda';
				this.configModal.subtitle = 'Vincular video de YouTube a League Sports';
				this.configModal.icon = 'fas fa-question-circle mr-1';
				break;
			case 'video_post_web':
				this.configModal.title = 'Ayuda';
				this.configModal.subtitle = 'Vincular video de la web a League Sports';
				this.configModal.icon = 'fas fa-question-circle mr-1';

			case 'registrar_marcador':
				this.configModal.title = 'Ayuda';
				this.configModal.subtitle = 'Registrar marcadores';
				break;
			default:
				break;
		}
	}

	onLoadVide(){
		// console.log('video loaded');
		this.loadingVideo = false;
	}
	onErrorVideo(){
		// console.log('error loaded');
		this.loadingVideo = false;
	}




	close(dataResult = null): void {
		this.dialogRef.close(dataResult);
	}
}
